import { useCallback } from "react";
import ReactTooltip from "react-tooltip";

import { LISSpecimen, SpecimenProtocolOverride } from "pwapi";

import { AccessionSpecimen } from "custom-models";

import { getProtocolStatus, protocolLabels } from "shared/utils/specimenUtils";

import { useSelectedLab } from "hooks/useSelectedLabStation";
import { specimenSort } from "util/sortFunctions";

export const SpecimenProtocolTags = ({
  dark = false,
  specimen,
  specimens,
}: {
  dark?: boolean;
  specimen: LISSpecimen | AccessionSpecimen;
  specimens: Array<LISSpecimen | AccessionSpecimen>;
}) => {
  // Define this as a callback so that we only actually perform these calculations when needed
  const lab = useSelectedLab();
  const getSlowMohsNames = useCallback(() => {
    if (
      specimen.slow_mohs_source_id === undefined &&
      (specimen as AccessionSpecimen).slow_mohs_source_name === undefined
    )
      return "";

    // If we are at Accessioning then the Specimens will not have IDs yet, and we use slow_mohs_source_name instead of slow_mohs_source_id
    const byName = !specimen.id && !specimen.slow_mohs_source_id;

    const slowMohsSpecimens = byName
      ? specimens.filter((s) =>
          [s.name, (s as AccessionSpecimen).slow_mohs_source_name].includes(
            (specimen as AccessionSpecimen).slow_mohs_source_name || ""
          )
        )
      : specimens.filter((s) =>
          [s.id, s.slow_mohs_source_id].includes(specimen.slow_mohs_source_id)
        );

    if (!slowMohsSpecimens.length) return "";

    slowMohsSpecimens.sort(specimenSort);

    return ` (${slowMohsSpecimens.map((s) => s.name).join(", ")})`;
  }, [specimen, specimens]);

  return (
    <>
      {specimen.protocols?.map((protocol) => (
        <div
          key={protocol}
          className={`Tag Tag--${dark ? "darkblue" : "blue"}`}
          data-tip={
            getProtocolStatus(
              specimen,
              protocol as SpecimenProtocolOverride.protocol,
              undefined,
              lab.settings
            ).reason
          }
        >
          {protocolLabels[protocol]}
          {protocol === SpecimenProtocolOverride.protocol.SLOW_MOHS &&
            getSlowMohsNames()}
        </div>
      ))}
      {!!specimen.protocols?.length && <ReactTooltip />}
    </>
  );
};

export default SpecimenProtocolTags;
